import { columnSetActionTypes } from "../Constants/ActionTypes";

const initialState = {
  isColumnSet: false,
  breakdownColumnSetData: {},
  isColumnSetDataChanged: false,
  columnSetStatusData: {},
};

export const ColumnSetReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case columnSetActionTypes.TOGGLE_CREATE_COLUMN_SET:
      return {
        ...state,
        isColumnSet: payload,
      };

    case columnSetActionTypes.SET_BREAKDOWN_COLUMN_SET_DATA:
      return {
        ...state,
        breakdownColumnSetData: payload,
      };

    case columnSetActionTypes.COLUMN_SET_STATUS_DATA:
      return {
        ...state,
        columnSetStatusData: payload,
      };

    default:
      return state;
  }
};
